module.exports = new __parcel__URL__("aws-mkt.d9293f27.png").toString();